export default function getRouteLinks({ isMortgageDeeplinkingEnabled, }) {
    return {
        alerts: {
            content: 'Alerts',
            bankUrl: '/alerts/bank-accounts',
            investUrl: `/sso/invest/tools/alert-center`,
            vehiclesUrl: '/alerts/vehicles',
            creditCardUrl: '/sso/credit-card/AccountMgmt/Alerts',
            creditScoreUrl: '/alerts/credit-score',
            mortgageUrl: '',
        },
        beneficiaries: {
            content: 'Beneficiaries',
            bankUrl: '/beneficiaries',
            investUrl: '/beneficiaries/invest',
            vehiclesUrl: '',
            creditCardUrl: '',
            creditScoreUrl: '',
            mortgageUrl: '',
        },
        contact: {
            content: 'Contact Us',
            bankUrl: '/contact',
            investUrl: '/contact',
            vehiclesUrl: '',
            creditCardUrl: '',
            creditScoreUrl: '',
            mortgageUrl: '',
        },
        directDeposit: {
            content: 'Direct Deposit',
            bankUrl: '/direct-deposit',
            investUrl: '',
            vehiclesUrl: '',
            creditCardUrl: '',
            creditScoreUrl: '',
            mortgageUrl: '',
        },
        forms: {
            content: 'Forms',
            bankUrl: '/bank/documents-and-forms',
            investUrl: '/bank/documents-and-forms',
            vehiclesUrl: '',
            creditCardUrl: '',
            creditScoreUrl: '',
            mortgageUrl: '',
        },
        notices: {
            content: 'Notices',
            bankUrl: '/bank/correspondence',
            investUrl: '',
            vehiclesUrl: '',
            creditCardUrl: '',
            creditScoreUrl: '',
            mortgageUrl: '/sso/home-loans',
        },
        paperlessSettings: {
            content: 'Paperless Settings',
            bankUrl: '/profile/paperless-settings',
            investUrl: '',
            vehiclesUrl: '',
            creditCardUrl: '',
            creditScoreUrl: '',
            mortgageUrl: '',
        },
        password: {
            content: 'Password',
            bankUrl: '/profile/password?focus=heading',
            investUrl: '',
            vehiclesUrl: '',
            creditCardUrl: '',
            creditScoreUrl: '',
            mortgageUrl: '',
        },
        privacyPreferences: {
            content: 'Privacy Preferences',
            bankUrl: '/profile/privacy-preferences',
            investUrl: '',
            vehiclesUrl: '',
            creditCardUrl: '',
            creditScoreUrl: '',
            mortgageUrl: '',
        },
        marketingPreferences: {
            content: 'Marketing Preferences',
            bankUrl: '/profile/privacy-preferences',
            investUrl: '',
            vehiclesUrl: '',
            creditCardUrl: '',
            creditScoreUrl: '',
            mortgageUrl: '',
        },
        profile: {
            content: 'Personal Information',
            bankUrl: '/profile',
            investUrl: '',
            vehiclesUrl: '',
            creditCardUrl: '',
            creditScoreUrl: '',
            mortgageUrl: '',
        },
        secureMessages: {
            content: 'Secure Messages',
            bankUrl: '/bank/secure-messages',
            investUrl: '/investments/secure-messages',
            vehiclesUrl: '',
            creditCardUrl: '',
            creditScoreUrl: '',
            mortgageUrl: '',
        },
        securityCode: {
            content: 'Login Security',
            bankUrl: '/profile/security-code-delivery?focus=heading',
            investUrl: '',
            vehiclesUrl: '',
            creditCardUrl: '',
            creditScoreUrl: '',
            mortgageUrl: '',
        },
        loginSecurity: {
            content: 'Login Security',
            bankUrl: '/profile/security-code-delivery',
            investUrl: '',
            vehiclesUrl: '',
            creditCardUrl: '',
            creditScoreUrl: '',
            mortgageUrl: '',
        },
        statements: {
            content: 'Statements and Tax Forms',
            bankUrl: '/bank/statements-and-forms',
            investUrl: `/sso/invest/accounts/activity-documents?documents=true`,
            vehiclesUrl: '',
            creditCardUrl: '/sso/credit-card/Account/OnlineStatement',
            creditScoreUrl: '',
            mortgageUrl: '',
        },
        documents: {
            content: 'Documents',
            bankUrl: '/bank/statements-and-forms',
            investUrl: `/sso/invest/accounts/activity-documents?documents=true`,
            vehiclesUrl: '',
            creditCardUrl: '/sso/credit-card/Account/OnlineStatement',
            creditScoreUrl: '',
            mortgageUrl: isMortgageDeeplinkingEnabled
                ? '/sso/home-loans/document-center'
                : '/sso/home-loans',
        },
        telebankingSecurity: {
            content: 'Telebanking Security',
            bankUrl: '/profile/telebanking-security?focus=heading',
            vehiclesUrl: '',
            investUrl: '',
            creditCardUrl: '',
            creditScoreUrl: '',
            mortgageUrl: '',
        },
        username: {
            content: 'Username',
            bankUrl: '/profile/username?focus=heading',
            investUrl: '',
            vehiclesUrl: '',
            creditCardUrl: '',
            creditScoreUrl: '',
            mortgageUrl: '',
        },
        orderChecks: {
            content: 'Order Checks',
            bankUrl: '/bank/checks-debit-cards',
            investUrl: '',
            vehiclesUrl: '',
            creditCardUrl: '',
            creditScoreUrl: '',
            mortgageUrl: '',
        },
        orderDebitCard: {
            content: 'Order Debit Card',
            bankUrl: '/payments/debit-card/order-card',
            investUrl: '',
            vehiclesUrl: '',
            creditCardUrl: '',
            creditScoreUrl: '',
            mortgageUrl: '',
        },
        manageDebitCard: {
            content: 'Manage Debit Card',
            bankUrl: '/payments/debit-card',
            investUrl: '',
            vehiclesUrl: '',
            creditCardUrl: '',
            creditScoreUrl: '',
            mortgageUrl: '',
        },
        replaceDebitCard: {
            content: 'Replace Debit Card',
            bankUrl: '/payments/debit-card/replace-card',
            investUrl: '',
            vehiclesUrl: '',
            creditCardUrl: '',
            creditScoreUrl: '',
            mortgageUrl: '',
        },
        ficoPreferences: {
            content: 'FICO® Auto Score Preferences',
            bankUrl: '',
            investUrl: '',
            vehiclesUrl: '/profile/fico-preferences',
            creditCardUrl: '',
            creditScoreUrl: '',
            mortgageUrl: '',
        },
    };
}
//# sourceMappingURL=RouteLookup.js.map